export default "__VITE_ASSET__50543765__"